import React from 'react';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { FaLinkedin } from 'react-icons/fa';
import logoImage from '../assets/images/logo.png';

const FooterContainer = styled.footer`
  width: 100%;
  background: rgb(0, 0, 0);
  backdrop-filter: blur(10px);
  padding: 2rem 5%;
  margin-top: auto;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
`;

const FooterTop = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  gap: 4rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
    gap: 3rem;
  }
`;

const FooterBottom = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-top: 2rem;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
  margin-top: 2rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 1rem;
    align-items: flex-start;
  }
`;

const FooterLogoContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.5rem;
`;

const Logo = styled.img`
  width: 40px;
  height: 40px;
  object-fit: contain;
`;

const FooterLogo = styled.div`
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
`;

const FooterLinksSection = styled.div`
  display: flex;
  gap: 6rem;
  
  @media (max-width: 768px) {
    flex-direction: column;
    gap: 3rem;
  }
`;

const FooterLinkGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;

  h3 {
    color: rgba(255, 255, 255, 0.4);
    font-size: 0.75rem;
    font-weight: 500;
    margin-bottom: 1rem;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
`;

const FooterLink = styled(Link)`
  color: rgba(255, 255, 255, 0.6);
  text-decoration: none;
  transition: color 0.3s ease;
  font-size: 0.85rem;
  letter-spacing: 0.3px;
  
  &:hover {
    color: white;
  }
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1rem;
`;

const SocialLink = styled.a`
  color: rgba(255, 255, 255, 0.8);
  font-size: 1.5rem;
  transition: color 0.3s ease, transform 0.3s ease;
  
  &:hover {
    color: white;
    transform: translateY(-3px);
  }
`;

const Copyright = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
  letter-spacing: 0.5px;
`;

const FooterAddress = styled.div`
  color: rgba(255, 255, 255, 0.4);
  font-size: 0.75rem;
  letter-spacing: 0.5px;
  line-height: 1.6;
`;

function Footer() {
  const currentYear = new Date().getFullYear();
  
  return (
    <FooterContainer>
      <FooterContent>
        <FooterTop>
          <FooterLogoContainer>
            <Logo src={logoImage} alt="GeoSpatios Logo" />
            <FooterLogo>GeoSpatios</FooterLogo>
          </FooterLogoContainer>
          
          <FooterLinksSection>
            <FooterLinkGroup>
              <h3>Company</h3>
              <FooterLink to="/">Home</FooterLink>
              <FooterLink to="/manifesto">Manifesto</FooterLink>
              <FooterLink to="/careers">Careers</FooterLink>
            </FooterLinkGroup>

            <FooterLinkGroup>
              <h3>Geo OS</h3>
              <FooterLink to="/geo-os">Overview</FooterLink>
              <FooterLink to="/geo-os/partner-program">Partner Program</FooterLink>
            </FooterLinkGroup>

            <FooterLinkGroup>
              <h3>Platform</h3>
              <FooterLink to="/platform/airfield-operations">Airfield Operations</FooterLink>
              <FooterLink to="/platform/maritime-operations">Maritime Operations</FooterLink>
              <FooterLink to="/platform/logistics-operations">Logistics Operations</FooterLink>
            </FooterLinkGroup>
          </FooterLinksSection>
          
          <SocialLinks>
            <SocialLink href="https://linkedin.com/company/geospatios" target="_blank" rel="noopener noreferrer">
              <FaLinkedin />
            </SocialLink>
          </SocialLinks>
        </FooterTop>
        
        <FooterBottom>
          <Copyright>
            © {currentYear} GeoSpatios. All rights reserved.
          </Copyright>
          
          <FooterAddress>
            USA
          </FooterAddress>
        </FooterBottom>
      </FooterContent>
    </FooterContainer>
  );
}

export default Footer; 